/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  GetVendorDetailsParams,
  VendorDetailDto
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getVendors = () => {
/**
 * Returns detailed diagnosis information for a specific vendor within the store/team
 * over the given period. Includes the vendor's summary statistics (average score,
 * diagnosis count) and a list of all their individual diagnoses with scores, families,
 * and days remaining until expiration. Used for drilling down into vendor performance.
 * @summary Get detailed diagnoses for a specific vendor
 */
const getVendorDetails = (
    storeId: number,
    teamId: number,
    vendorId: string,
    params: GetVendorDetailsParams,
 ) => {
      return customInstance<VendorDetailDto>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/vendors/${vendorId}/details`, method: 'GET',
        params
    },
      );
    }
  return {getVendorDetails}};
export type GetVendorDetailsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVendors>['getVendorDetails']>>>
